import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Promotion } from "../..";
import { ModalContentType } from "../../../enums/index";
import { ModalContainer } from "../../../shared/index";

function Actions(props) {
  const [details, setDetails] = useState({ data: [] })

  const coupon = useRef();


  useEffect(() => {
    let temp = { ...details }
    temp.data = [props?.details]
    setDetails({ ...temp });
  }, [props])

  const handleClose = (e = null, submit = null) => {
        if (submit) props.createCoupons(coupon.current);
    else {
      e?.preventDefault();
      props.setCoupon({})
      props.setShowModal(false)
    }

  };

  return (
    <>
      <Row className="ltr">
        <Col xxl="auto" xl="auto" lg="2" md="3" xs="4">
          <div className="panel-head-action coupon">
            {" "}
            <Button
              className="login-as-user-btn"
              onClick={(e) => props?.setShowModal(true)}
            >
              {props.Headings.CouponCreateBtn}
            </Button>
          </div>
        </Col>
        <Col t className="d-flex justify-content-start" xxl="auto" xl="auto" lg="2" md="3" xs="4">
          <div className='custom-select'>
            <select style={{ padding: '8px 10px 3px 31px' }} className="custom form-control" value={props?.dropDownFilter} onChange={(e) => {
              props?.setDropDownFilter(e.target.value)
            }
            }>
              <option value={true}>کدهای فعال</option>
              <option value={false}>کدهای غیر فعال</option>
            </select>
          </div>

        </Col>
      </Row>
      <ModalContainer
        show={props.showModal}
        type={ModalContentType.Coupon()}
        title={props.Headings.CouponModalTitle}
        handleClose={handleClose}
        data={{
          coupon: coupon,
        }}
        token={props.token}
        setCoupon={props.setCoupon}
        coupon={props.coupon}
      ></ModalContainer>
    </>
  )
}
export default Actions;
